var render = function render(_c,_vm){return _c('transition',{attrs:{"name":"bounce"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }